// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"b6d638b6","510":"aab154d1","530":"0be90e84","692":"eb75c0ef","698":"c9f782a9","807":"6a094055"}[chunkId] + ".chunk.css";
};